import { combineReducers } from "@reduxjs/toolkit";
import { reducer as toastrReducer } from "react-redux-toastr";
import { authConstants } from "@/config/constants";

import authReducer from "@/features/auth/store/authSlice";
import resetPasswordReducer from "@/features/auth/store/resetPasswordSlice";
import userReducer from "@/features/profile/store/userSlice";
import brandReducer from "./brandSlice";
import campaignReducer from "@/features/campaigns/shared/store/campaignSlice";
import settingsReducer from "./settingsSlice";
import themeReducer from "./themeSlice";

const appReducer = combineReducers({
  toastr: toastrReducer,
  auth: authReducer,
  resetPassword: resetPasswordReducer,
  user: userReducer,
  brand: brandReducer,
  campaign: campaignReducer,
  settings: settingsReducer,
  theme: themeReducer,
});

export const rootReducer = (state, action) => {
  if (action.type === authConstants.LOGOUT) {
    state = undefined;
  }
  return appReducer(state, action);
};
